import React, { FC, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Popover } from "@evergis/ui";

import { LocalLinkBlank, LocalLinkButton, LocalLinkCopy } from "./styled";
import { useToggle } from "../../../../hooks/useToggle";

export const LocalLink: FC<{ link: string }> = memo(({ link }) => {
  const { t } = useTranslation("common");
  const [isOpen, toggleOpen] = useToggle();

  const onCopy = useCallback(() => {
    navigator.clipboard.writeText(link);
    toggleOpen();
  }, [link, toggleOpen]);

  return (
    <Popover
      open={isOpen}
      zIndex={10}
      onRequestClose={toggleOpen}
      anchorOrigin="bottom-right"
      targetOrigin="top-right"
      anchor={<LocalLinkButton onClick={toggleOpen} />}
    >
      <LocalLinkBlank>
        <a href={link} target="_blank" rel="noreferrer">
          {link}
        </a>
        <LocalLinkCopy>
          <IconButton kind="copy" onClick={onCopy}>
            {t("actions.copy")}
          </IconButton>
        </LocalLinkCopy>
      </LocalLinkBlank>
    </Popover>
  );
});
